import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3402';

export interface UserSettings {
  notifications: {
    emailDigest: 'daily' | 'weekly' | 'never';
    creatorUpdates: boolean;
    newPosts: boolean;
    comments: boolean;
    messages: boolean;
    newsletters: boolean;
    promotions: boolean;
  };
  privacy: {
    profileVisibility: 'public' | 'patrons-only' | 'private';
    showPatronCount: boolean;
    showActivity: boolean;
    allowMessages: 'everyone' | 'patrons' | 'none';
    showInSearch: boolean;
  };
  preferences: {
    language: string;
    timezone: string;
    currency: string;
    theme: 'light' | 'dark' | 'auto';
    contentFilter: 'off' | 'moderate' | 'strict';
  };
  data: {
    allowDataCollection: boolean;
    allowPersonalization: boolean;
    allowThirdParty: boolean;
  };
}

export const settingsService = {
  /**
   * Get user settings
   */
  async getSettings(): Promise<UserSettings> {
    const token = localStorage.getItem('accessToken');
    const response = await axios.get(`${API_BASE_URL}/api/settings`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.settings;
  },

  /**
   * Update user settings
   */
  async updateSettings(settings: UserSettings): Promise<UserSettings> {
    const token = localStorage.getItem('accessToken');
    const response = await axios.put(
      `${API_BASE_URL}/api/settings`,
      settings,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.settings;
  },

  /**
   * Partially update user settings
   */
  async patchSettings(partialSettings: Partial<UserSettings>): Promise<UserSettings> {
    const token = localStorage.getItem('accessToken');
    const response = await axios.patch(
      `${API_BASE_URL}/api/settings`,
      partialSettings,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.settings;
  },

  /**
   * Reset settings to defaults
   */
  async resetSettings(): Promise<UserSettings> {
    const token = localStorage.getItem('accessToken');
    const response = await axios.post(
      `${API_BASE_URL}/api/settings/reset`,
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data.settings;
  },
};
